<template>
    <div>
        <Query ref="queryRef" @query-click="handleQueryClick"/>
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <el-button type="text" @click="handleSelect('all')">全选</el-button>
                    <span :style="{padding: '0 6px'}">/</span><el-button type="text" @click="handleSelect('cannel')">反选</el-button>
                    <el-button type="primary" size="mini"
                               v-if="getCurAuth('batch_download_material')"
                               v-matomo="{behaviorCategory: '素材库(素材管理)', event: '点击',  name: '批量下载素材' }"
                               :style="{marginLeft: '30px'}" @click="handleGroupDown">批量下载</el-button>
                    <el-button type="primary"
                               v-if="getCurAuth('upload_material')"
                               v-matomo="{behaviorCategory: '素材库(素材管理)', event: '点击',  name: '上传' }"
                               size="mini" @click="handleCreate">上传</el-button>
                </div>
                <div class="operation-right"></div>
            </div>
            <div v-loading="loading" ref="store-table" style="min-height: calc(100vh - 300px)">
            <div class="store-table"  v-if="list.length > 0">
                <div v-for="(item, index) in list" :key="index" class="store-table-item">
                    <MaterialExtendItem :preview="false" :expandMaterial="item" @click-preview="handlePreView(item)">
                        <template v-slot:checkBox>
                            <el-checkbox :value="item.checked" @change="(value)=>handleChange(value, index)"></el-checkbox>
                        </template>
                        <template v-slot:leftBtn>
                            <el-button type="primary" size="mini"
                                       v-if="getCurAuth('download_material')"
                                       :loading="item.downloading"
                                       v-matomo="{behaviorCategory: '素材库(素材管理)', event: '点击',  name: '下载' }"
                                       @click="handleOnlyDown(item)">下载</el-button>
                        </template>
                        <template v-slot:footer>
                            <el-button type="danger" size="mini"
                                       v-if="getCurAuth('delete_material') && item.source == 2"
                                       @click="handleDel(item)">删除</el-button>
                            <el-button type="primary" size="mini"
                                       v-if="getCurAuth('edit_material')"
                                       v-matomo="{behaviorCategory: '素材库(素材管理)', event: '点击',  name: '编辑' }"
                                       plain @click="handleEdit(item)">编辑</el-button>

                        </template>
                    </MaterialExtendItem>
                </div>
                <!--使用占位元素,补齐最后一行空缺的item,以保证最后一行的展示效果-->
                <!-- <div class="pad-store-table-item store-table-item" v-for="(item, ix) of padNum" :key="'padnum_'+ix"></div> -->
            </div>
                <div v-else style="text-align: center;max-height: 220px;">
                    暂无数据
                </div>

            <div class="tar pt20 pr20">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="pageNum" :page-sizes="pageSizes" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Query from './query.vue'
import MaterialExtendItem from '../../../components/materialExtendItem.vue'
import {storePreviewModal, uploadMaterialModal} from "@/views/workOrder/modal";
import {downLoadModal} from '../modal'
import API from "@/api/workOrder/store.js"
import MaterialsTableExpand from "@/views/workOrder/material/pages/taskInfo/tableExpand.vue";
import {cloneDeep,find} from 'lodash'
import {downloadFile} from '@/views/workOrder/components/utils.js'
import matomoFun from "@/utils/matomo.js";
export default {
    name: 'storePage',
    components: {
        MaterialsTableExpand,
        Query,
        MaterialExtendItem
    },
    props:{
        pageFuncNames:Array,
    },
    data() {
        return {
            query:{},
            list: [],
            checked:false,
            value: '1',
            pageSize: 30,
            pageSizes: [30, 50, 100],
            pageNum: 1,
            total: 0,
            loading: false,
            paramsData: {},//检索参数
            padNum:0,
        }
    },
    computed:{
        ...mapState({
            sidebarOpened:state => state.app.sidebar.opened,
        }),
    },
    watch:{
        // sidebarOpened(){
        //     setTimeout(()=>{
        //         this.getPadNum();
        //     },300);
        // },
    },
    mounted() {
        // this.$nextTick(()=>{
        //     const width = this.$refs['store-table']?.clientWidth;
        //     const pageSize = Math.floor(width/(300 + 10)) * 4;
        //     if (pageSize>30) {
        //         this.pageSize =  pageSize;
        //         this.pageSizes.unshift(pageSize)
        //     }

        //     this.getPadNum();
        // });
        // window.addEventListener("resize", this.getPadNum);
    },
    methods:{
        // getPadNum(){
        //     /* 动态计算最后一行的数量 */
        //     const width = this.$refs['store-table']?.clientWidth;
        //     // console.log('width',width);
        //     const rowNum = Math.floor(width/(300 + 10));
        //     if((this.list.length % rowNum) != 0){
        //         let padNum = rowNum - (this.list.length % rowNum);
        //         this.padNum = padNum;
        //     }else{
        //         this.padNum = 0;
        //     }
        // },
        // storeUploadModal,
        // storePreviewModal,
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        pushMatomo(name) {
            matomoFun.trackEvent('素材库(素材管理)', '点击', name)
        },
        // 素材列表
        fetchGetList(query) {
            this.loading = true;
            const params = {
                ...query,
                pn:this.pageNum,rn:this.pageSize
            }
            API.getStoreList(params).then(res=>{
                this.list = res.data.list.map(item=>{
                    item['all_labels'] = (item.delete_labels||[]).concat(item.label_list);
                    item['checked'] = false;
                    item['downloading'] = false
                    return {...item};
                });
                this.total = res.data.totalCnt
            }, err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.loading = false
                // this.getPadNum();
            })
        },

        // 素材删除
        handleDel(rows) {
            this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.postStoreDel({material_id:rows.id, source: rows.source}).then(res=>{
                    this.$message.success(res.info)

                    let res_params = {...this.query};
                    this.paramsData = res_params;
                    // 第一次等待 每页数量算出后再更新数据
                    Promise.resolve().then(()=>this.fetchGetList(res_params))

                },err=>{
                    this.$message.error(err.info)
                })
            }).catch(() => {
            });
        },
        // 素材预览
        handlePreView(rows) {
            this.pushMatomo('查看素材详情')
            const {vm} = storePreviewModal({
                props: {
                    id: rows.id,
                    list:this.list,
                    fromTitle: '素材库(素材管理)',
                    fetch: 'getPreview', //请求不同给的接口
                    authEdit: this.getCurAuth('edit_material'),
                    authDown: this.getCurAuth('download_material'),
                    downFetch: 'getOnlyDownLoad',
                    authDownHref: `/td/api/material_storehouse/download`,
                    authStoreDel: this.getCurAuth('del_material') && rows.source == 2 ? true : false,
                },
                cbs:{
                    onSubmit:(data)=>{
                        console.log('触发详情关闭',data);
                    },
                    onClose:() => {
                        vm.close()
                    },
                    onEdit:(data)=>{
                        console.log('onEdit',data);
                        let rowData = this.list.find(item=>item.material_md5==data.material_md5);
                        this.handleEdit(Object.assign({},rowData,data));
                    },
                    onDel: (data) => {
                        return new Promise((resolve, reject) => {
                            this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                API.postStoreDel({material_id:rows.id, source: rows.source}).then(res=>{
                                    this.$message.success(res.info)

                                    let res_params = {...this.query};
                                    this.paramsData = res_params;
                                    resolve()
                                    // 第一次等待 每页数量算出后再更新数据
                                    Promise.resolve().then(()=>this.fetchGetList(res_params))

                                },err=>{
                                    reject()
                                    this.$message.error(err.info)
                                })
                            }).catch(() => {
                                reject()
                            });
                        })
                        
                    }
                },
                on:{
                    close:()=>{
                        vm.close()
                        this.pushMatomo('查看素材详情(关闭)')
                    }
                }
            })
        },
        // 素材上传
        handleCreate() {
            this.pushMatomo('上传')
            const {vm} = uploadMaterialModal({
                props: {
                    title: '素材上传',
                    isBatch:false,
                    behaviorCategory:'素材库(素材管理)',
                    name: '上传(上传提交)'
                },
                cbs:{
                    onSubmit:(data)=>{
                        this.$store.commit('workOrder/ADD_TASK_ITEM', data);
                    },
                },
                on:{
                    close:()=>{
                        vm.close()
                        this.pushMatomo('上传(取消)')
                    }
                }
            })
        },
        // 素材编辑
        handleEdit(item) {
            this.pushMatomo('编辑')
            const {vm} = uploadMaterialModal({
                props: {
                    title: '素材编辑',
                    isBatch:false,
                    isEdit:true,
                    materialInfo:{...item},
                    behaviorCategory:'素材库(素材管理)',
                    name: '编辑(保存)'
                },
                cbs:{
                    onSubmit:(data)=>{
                        this.$refs.queryRef.handleOnSubmit();
                    },
                },
                on:{
                    close:()=>{
                        vm.close()
                        this.pushMatomo('编辑(取消)')
                    }
                }
            })
        },
        // 查询结果
        handleQueryClick(params) {
            this.pageNum = 1;
            console.log(params)
            this.query = params
            let res_params = {...this.query};
            this.paramsData = res_params;
            // 第一次等待 每页数量算出后再更新数据
           Promise.resolve().then(()=>this.fetchGetList(res_params))
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNum = 1;
            this.fetchGetList(this.paramsData)
        },
        // 当前页数
        handleCurrentChange(val) {
            this.pageNum = val;
            this.fetchGetList(this.paramsData)
        },
        // 设置 选中
        handleChange(value, index) {
            console.log(value, index)
            this.$set(this.list, index, {...this.list[index], checked:value})
        },
        // 全选 反选
        handleSelect(type) {
            let res_obj = []
            let cloneDeepList = cloneDeep(this.list)
            if(type == 'all') {
                if(cloneDeepList.every(item=>item['checked'])) {
                    res_obj = cloneDeepList.map(item=>{item['checked'] = false; return item})
                }else{
                    res_obj = cloneDeepList.map(item=>{item['checked'] = true; return item})
                }
            }else{
                res_obj = cloneDeepList.map(item=>{item['checked'] = !item['checked']; return item})
            }
            this.list = res_obj
        },
        // 批量下载
        handleGroupDown() {
            let group_ids = this.list.filter(item=>item['checked'])
            if(!group_ids || group_ids.length == 0) {
                return this.$message.warning('请选择素材后操作')
            }
            const { vm } = downLoadModal(
                {
                    props: {
                        list:group_ids,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            vm.close()
                        },
                    }
                }
            )
        },
        // 单独下载
        handleOnlyDown(rows) {
            rows['downloading'] = true
            API.getOnlyDownLoad({material_id:rows.download_id, source: rows.source}).then(res=>{
                let result = res.data
                downloadFile(result)
            },err=>{
                this.$message.error(err.info||'请求异常');
            }).finally(()=>{
                rows['downloading'] = false
            })
        },
    },
    beforeDestroy(){
        // window.removeEventListener("resize", this.getPadNum);
    },
}
</script>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";
// .store-table{
//     display: flex;
//     flex-wrap: wrap;
//     justify-content: space-evenly;
//     &>.pad-store-table-item {
//         width:300px;
//     }
//     .store-table-item{
//         margin-right: 10px;
//         margin-bottom: 10px;
//     }
// }
.store-table{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, 310px);
    gap: 20px;
    justify-content: center;
}

.operation-left{
    display: flex;
    align-items: center;
}
</style>
